import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/dialogue/radix-dialog";
import MonthlyPayroll from "./MonthlyPayroll";
import SalarySlipClient from "./SalarySlipClient";
const PayrollDetailsDialogue = ({ children, payroll }) => {
  return (
    <Dialog>
      <DialogTrigger>{children}</DialogTrigger>
      <DialogContent className="max-w-4xl rounded-2xl p-6 bg-card h-[90dvh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-gray-800">
            Payroll Details
          </DialogTitle>
        </DialogHeader>
        <MonthlyPayroll payroll={payroll} />
        <SalarySlipClient payroll={payroll} />
      </DialogContent>
    </Dialog>
  );
};

export default PayrollDetailsDialogue;
